import { IUser } from '@connec10/media-interface/src/entity'
import { UpdateMeRequest, UpdateMeResponse } from '@connec10/media-interface/src/request'
import { useState } from 'react'
import useSWR, { mutate } from 'swr'
import { axios } from '../../libs'
import { SWRCachePath } from '../swr-cache-path'

export const useGetMe = () => {
  const { data, error } = useSWR<IUser>(SWRCachePath.ME, () =>
    axios.get('/me').then(res => {
      const data = res.data
      return data.user
    })
  )
  return {
    user: data,
    error,
    isLoading: !data && !error
  }
}

export const useUpdateMe = () => {
  const [error, setError] = useState<Error | undefined>(undefined)
  const [isLoading, setIsLoading] = useState<boolean>(false)

  const handleUpdateMe = async (data: UpdateMeRequest['body']) => {
    if (isLoading) return
    setIsLoading(true)
    setError(undefined)
    try {
      const user = await axios.patch<UpdateMeResponse>('/me', data).then<IUser>(res => res.data.user)
      setIsLoading(false)
      mutate(SWRCachePath.ME, user)
    } catch (err) {
      setIsLoading(false)
      setError(err)
    }
  }

  return {
    handleUpdateMe,
    error,
    isLoading
  }
}
